import "./notificationBoxSmall.css"

export function NotificationBoxSmall({ notification, notificationPopup, setNotificationPopup }) {
    return (
        <div className={`notification-popup-small px-4 py-3 bg-white rounded-1 d-flex justify-content-between  align-items-center gap-5 ${notificationPopup ? "on" : ""}`}
            onClick={(e) => e.preventDefault()}>
                
                {
                    notification.type.includes("ERROR") ?
                        <div className="error-icon"></div>
                        :
                        <div className="success-icon"></div>
                }
                
                <div className="popup-text">
                    {
                        notification.type === "ADD_TO_WISHLIST" ?
                        "Item added to your wishlist"
                        : notification.type === "ADD_TO_CART" ?
                        "Item added to cart"
                        : notification.type === "UPDATE_CART_ITEM" ?
                        "Cart Item updated"
                        : notification.type === "UPDATE_CART" ?
                        "Cart updated"
                        : notification.type === "UPDATE_PROFILE" ?
                        "Profile changes saved"
                        : notification.type === "ADD_PRODUCT" ?
                        "New product added"
                        : notification.type === "UPDATE_PRODUCT" ?
                        "Product updated"
                        : notification.type === "DELETE_PRODUCT" ?
                        "Product deleted"
                        : notification.type === "PLACE_ORDER" ?
                        "Order placed"
                        : notification.type === "UPDATE_ORDER" ?
                        "Order status updated"
                        : notification.type.includes("ACTION_FORBIDDEN") ?
                        "Action Forbidden"
                        : 
                        ""
                    }
                </div>
                <div>
                    <i
                        className="fa-solid fa-x border p-2 rounded-circle"
                        onClick={() => setNotificationPopup(false)}>
                    </i>
                </div>
        </div>
    )
}